<div class="custom-tabs">
  <div class="tab-header">
    @for (tab of tabs; track tab.label; let i = $index) {
    <button class="tab-button" [class.active]="selectedIndex === i" (click)="onTabClick(i)"
      (keyup.enter)="onTabClick(i)" tabindex="0">
      <span class="tab-label-badge"
        [matBadge]="tab.badgeCount || null"
        matBadgeColor="warn"
        [matBadgeHidden]="!tab.badgeCount"
        [matBadgeOverlap]="false">
        <i class="fa {{ tab.icon }}"></i>&nbsp;&nbsp;
        <span>{{ tab.label }}</span>
      </span>
    </button>
    }
    <div class="tab-ink-bar" [class.second-tab]="selectedIndex === 1"></div>
  </div>
</div>